import angular from 'angular';
import ngRedux from 'ng-redux';

// Import the app to get access to the store
import App from '../app';

const config = $ngReduxProvider => {
  'ngInject';
  // Provide the pre-configured store to ngRedux
  $ngReduxProvider.provideStore(App.store);
};

const stateModule = angular
  .module('app.state', [ngRedux])
  .config(config)
  .run();

export default stateModule.name;
